import { createHashRouter } from "react-router-dom";
import App from "../App";
import { PolicyRouting } from "@components/policy/policy-routing.components";
import React from "react";

export const AppRoutes = createHashRouter([
  {
    path: "/",
    element: <App />,
    children: [...PolicyRouting({ path: "policy" })],
  },
]);
